import {
  IEditEquipment,
  IEquipment,
  IGetAllParams,
  IGetAllResponse,
  IGetEquipment,
  IAddSensor,
  IAlertByDevice,
  ITranferDevicesResponse,
  IGetTranferDevicesParams,
  IAddTranferList,
  ITranferItem,
  IActiveDevice,
  IGetActiveDevice,
} from '~/utils/interface/equipment';
import axiosClient from './axiosClient';

const equipmentApi = {
  getAll() {
    const url = '/api/device/getall';
    return axiosClient.get<any>(url);
  },
  getOverviewData(data: IGetAllParams) {
    const url = `/api/device/find`;
    return axiosClient.post<IGetAllResponse>(url, data);
  },
  createEquipment(data: IEditEquipment) {
    return axiosClient.post<IGetAllResponse>('/api/device/create', data);
  },
  getEquipment(params: IGetEquipment) {
    return axiosClient.get<IEquipment>('/api/device/get', { params });
  },
  updateEquipment(data: IEditEquipment) {
    return axiosClient.post<IGetAllResponse>('/api/device/update', data);
  },
  addSensor(data: IAddSensor) {
    return axiosClient.post<IAddSensor>('/api/sensor/add-sensor', data);
  },
  updateSensor(data: IAddSensor) {
    return axiosClient.post<IAddSensor>('/api/sensor/update-sensor', data);
  },
  deleteSensor(data: IAddSensor) {
    return axiosClient.post<IAddSensor>('/api/sensor/remove-sensor', data);
  },
  getAlertByDevice(deviceId: number) {
    return axiosClient.get<IAlertByDevice[]>(`/api/device/alerts-by-device/${deviceId}`);
  },
  deleteDevice(device_id: number) {
    return axiosClient.delete<any>(`/api/device/delete/${device_id}`);
  },
  importDevice(data: IAddSensor[]) {
    return axiosClient.post<IGetAllResponse>('/api/device/insert-multiple', data);
  },
  searchDevice(params: any) {
    return axiosClient.get<any>(`/api/device/search`, { params });
  },
  getListTranferDevices(params: IGetTranferDevicesParams) {
    return axiosClient.get<ITranferDevicesResponse>('/api/device/list-transfer-device', { params });
  },
  addTranferList(data: IAddTranferList) {
    return axiosClient.post<ITranferItem[]>('/api/device/add-transfer-list', data);
  },
  getTranferList(username: string) {
    return axiosClient.get<ITranferItem[]>(`/api/device/transfer-list/${username}`);
  },
  deleteTranferList(id: string) {
    return axiosClient.delete<ITranferItem[]>(`/api/device/transfer-list/${id}`);
  },
  confirmTranferList(id: string) {
    return axiosClient.post<ITranferItem[]>(`/api/device/confirm-transfer/${id}`);
  },
  activateDevices(data: IActiveDevice) {
    return axiosClient.post<IGetActiveDevice>('/api/device/activate-devices', data);
  },
};
export default equipmentApi;
